<template>
  <div class="user-abilities-container">
    <table>
      <thead>
        <th class="pl-0">page access</th>
        <th>view</th>
        <th>edit existing</th>
        <th>create/delete</th>
      </thead>
      <tbody>
        <tr v-for="page in accessPages" :key="page.name">
          <td>{{page.name}}</td>
          <td v-for="level in page.levels">
            <label :for="level.id" class="flex justify-center">
              <input
                  v-model="userAbilitiesArray"
                  :class="[{ disabled: !level.value }]"
                  :disabled="!level.value"
                  :ref="level.id"
                  :id="level.id"
                  type="checkbox"
                  :value="level.value"
                  @change="checkboxChanged">
              <span class="checkmark"></span>
            </label>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import UserAbilitiesMixin from '../../mixins/UserAbilitiesMixin'
  import AccessPagesMixin from '../../mixins/AccessPagesMixin'

  export default {
    props: {
      userAbilitiesValue: Number,
    },

    name: 'AccessPages',

    mixins: [AccessPagesMixin, UserAbilitiesMixin],

    data() {
      return {
        userAbilitiesArray: [],
      }
    },

    methods: {
      addToAbilitiesArray(bitValue) {
        if (this.userAbilitiesArray.includes(bitValue)) { return }
        this.userAbilitiesArray.push(bitValue)
      },

      checkboxChanged(event) {
        const target = event.target,
            id = target.id,
            isChecked = target.checked

        if (target.value === 'all') {
          isChecked ? this.setAbilitiesArray(true) : this.userAbilitiesArray = []
          return
        }
        this.checkActionDependencies(id, isChecked)
        if (isChecked) { this.checkPageDependencies(id) }
      },

      emitUserAbilities() {
        this.$emit('updateUserAbilities', 'userAbilities', this.userAbilitiesArray)
      },

      setAbilitiesArray(selectAll) {
        const abilities = this.abilities
        let array = []

        for (const page in abilities) {
          let shouldAddPage = (selectAll || this.hasAccess(this.userAbilitiesValue, page))
          if (shouldAddPage) { array.push(abilities[page]) }
        }
        this.userAbilitiesArray = array
      },

      updateSelectAllCheckbox() {
        const abilitiesArraySum = this.userAbilitiesArray.reduce((a, b) => a + b, 0n),
            abilitiesSum = this.sumAbilityValues(),
            isAllAbilities = abilitiesArraySum === abilitiesSum

        this.$refs.select_all[0].checked = isAllAbilities ? true : false
      },
    },

    created() {
      this.buildAccessPages()
    },

    watch: {
      userAbilitiesValue: function() {
        if (!!this.userAbilitiesValue) { this.setAbilitiesArray() }
      },

      userAbilitiesArray: function() {
        this.emitUserAbilities()
        this.updateSelectAllCheckbox()
      }
    }
  }
</script>
